import { ImagePlus, ListChecks, Save, X } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import env from 'react-dotenv';
import User from '../../Models/User';
import { Crypter } from '../../Functions/Security/Crypter';
import datas from "../../Assets/data.json";
import { FormSection, FormActions, PickerList, useAlert, Input, Textarea, Button, Spin, Modal } from '../ui';


export interface ConfirmationDialogRawProps {
    classes: Record<'paper', string>;
    id: string;
    keepMounted: boolean;
    value: string;
    open: boolean;
    onClose: (value?: string) => void;
}

export interface Ticket {
    numeroFile: string,
    guichet: string,
    agence: String
}

const FormPubUpdate = (props: { codePromo?: string, handleFunction: any, pub: any, file?: string }) => {
    // USER TOKEN
    const authHeader = useAuthHeader()
    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert();

    const { register, handleSubmit, setValue, reset } = useForm()
    const [isOk, setIsOk] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [services, setservices] = useState<string[]>([])
    const [rows, setRows] = useState([])
    const [openServices, setOpenServices] = useState(false)
    const [imgDims, setImgDims] = useState('')
    const [dragOver, setDragOver] = useState(false)
    const fileInputRef = useRef<HTMLInputElement>(null)

    /** Médias de la pub (dataURLs) — plusieurs images possibles. */
    const [mediaFiles, setMediaFiles] = useState<string[]>([])

    /** Taille max fichier (5 Mo) — le cadre pub du Live Screen ≈ 3:2. */
    const MAX_SIZE = 5 * 1024 * 1024
    const TARGET_RATIO = 1.5

    /** FIchiers peut être une chaîne JSON (tableau) ou un dataURL seul. */
    function parseFichiers(raw: string): string[] {
        try {
            const p = JSON.parse(raw)
            return Array.isArray(p) ? p : [raw]
        } catch {
            return raw ? [raw] : []
        }
    }

    useEffect(() => {
        loadSercices()
        if (props.file) {
            setMediaFiles(parseFichiers(props.file))
        } else {
            loadPubFile()
        }
        if (props.pub) {
            setValue("PubID", props.pub[0].PubID)
            setValue("Statut", props.pub[0].Statut)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    /** Charge les fichiers existants de la pub (GetFichiersByPubID?CipherPubID=). */
    function loadPubFile() {
        const pubId = props.pub?.[0]?.PubID
        if (pubId === undefined || pubId === null) return
        setLoading(true)
        axios.request({
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Pub.GetFichiersByPubID + '?CipherPubID=' + Crypter.encrypt(String(pubId)),
            headers: { 'Accept': 'text/plain', 'Authorization': authHeader() },
        })
            .then((response) => {
                setLoading(false)
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                const fichier = res?.Result?.[0]?.[0]?.FIchiers || res?.Result?.[0]?.[0]?.Fichiers
                if (fichier) {
                    const medias = parseFichiers(fichier)
                    setMediaFiles(medias)
                    const img = new Image()
                    img.onload = () => setImgDims(`${img.naturalWidth} × ${img.naturalHeight} px`)
                    img.src = medias[0]
                }
            })
            .catch(() => setLoading(false))
    }

    function loadSercices() {
        setLoading(true)

        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.GetAllServices + Crypter.encrypt(user.CodeAbonne),
            headers: {
                'Authorization': authHeader(),
            }
        };
        axios.request(config)
            .then((response) => {
                setLoading(false)
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    const services: any = []

                    res.Result.map((s: any) => {
                        services.push({ id: s.CodeS, codeFiliale: s.CodeFiliale, libelle: s.Libelle, },)
                    })
                    setRows(services)

                    const model: any = []

                    props.pub?.[1]?.map((h: any) => {
                        model.push(h.CodeS)
                    })

                    setservices(model)

                    // alert(JSON.stringify(res.Result))
                } else {
                    alert.warning(res.Message)
                }
            })
            .catch((error) => {
                setLoading(false)
                alert.error(error.message)
            });
    }
    const onSubmit = async (data: any) => {

        setLoading(true)
        if (services.length > 0) {
            if (mediaFiles.length > 0) {

                // Modèle Pub (doc) — UpdatePubAndServices : Titre/Fichiers/Statut + ré-affectation
                data = {
                    PubID: props.pub?.[0]?.PubID,
                    Titre: data.Titre,
                    Libelle: data.Libelle,
                    Fichiers: JSON.stringify(mediaFiles),
                    Habilitations: "[]",
                    IsActif: data.Statut ? "true" : "false",
                    DatePub: data.DatePub || undefined,
                    ListeService: services.join("|"),
                    Roleid: parseInt(user.RoleId) || 0,
                    CreatedBy: user.CodeU,
                }

                // POST /api/Pub/UpdatePubAndServices — objet Pub chiffré dans le corps (schema "string")
                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: env.API_BASE_URL + datas.API_LINKs.Pub.UpdatePub,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': authHeader(),
                    },
                    data: Crypter.encrypt(JSON.stringify(data)),
                };

                // console.log(Crypter.encrypt(JSON.stringify(data)))
                axios.request(config)
                    .then((response) => {
                        setLoading(false)
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value
                        if (res.StatutCode == 200 || res?.Result?.Table?.[0]?.Statut == 200) {
                            alert.success(res.Message || res?.Result?.Table?.[0]?.Message || 'Publicité modifiée')
                            reset()
                            props.handleFunction()
                        } else {
                            alert.warning(res.Message || res?.Result?.Table?.[0]?.Message || 'Modification refusée')
                        }
                    })
                    .catch((error) => {
                        setLoading(false)
                        alert.error(error.message)
                    })

            }
            else {
                alert.warning("Veillez sélectionner au moins un fichier.")
            }
        }
        else {
            alert.warning("Veillez sélectionner les services.")
        }
    }

    const pickerItems = rows.map((r: any) => ({ id: r.id, label: r.libelle, group: r.codeFiliale }));

    /** Upload partagé (click + drag-and-drop, multi) : image seule, ≤5 Mo, ratio conseillé 3:2. */
    function handleFile(file: File) {
        if (!file.type.startsWith('image/')) {
            alert.warning("Images uniquement (PNG, JPG, SVG…).")
            return
        }
        if (file.size > MAX_SIZE) {
            alert.warning(`« ${file.name} » dépasse la taille maximale de 5 Mo.`)
            return
        }
        setLoading(true)
        getBase64(file).then((base64) => {
            const img = new Image()
            img.onload = () => {
                setImgDims(`${img.naturalWidth} × ${img.naturalHeight} px`)
                const ratio = img.naturalWidth / img.naturalHeight
                if (Math.abs(ratio - TARGET_RATIO) / TARGET_RATIO > 0.25) {
                    alert.warning(`« ${file.name} » (${img.naturalWidth}×${img.naturalHeight}) — pour un rendu optimal sur le Live Screen, visez ~1200×800 px (ratio 3:2).`)
                }
            }
            img.src = base64
            setMediaFiles((prev) => [...prev, base64])
            setLoading(false)
        }).catch(() => {
            setLoading(false)
            alert.error("Erreur lors de la conversion du fichier.")
        })
    }

    function handleFiles(files: FileList | null) {
        if (!files) return
        Array.from(files).forEach(handleFile)
    }

    function removeMedia(index: number) {
        setMediaFiles((prev) => prev.filter((_, i) => i !== index))
    }

    const getBase64 = (file: any): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });


    return (
        <>
            <Spin spinning={loading}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormSection title="Info Pub" subtitle="Code, titre et statut de la publicité">
                        <Input
                            disabled
                            onKeyUp={() => setIsOk(false)}
                            {...register("PubID")}
                            required
                            defaultValue={props.pub?.[0]?.PubID}
                            type='text'
                            label={'Code Publicité'}
                            placeholder={"Entrez le code de la publicité"} />
                        <Input
                            onKeyUp={() => setIsOk(false)}
                            {...register("Libelle")}
                            defaultValue={props.pub?.[0]?.Libelle}
                            required
                            type='text'
                            label={'Libellé'}
                            placeholder={"Entrez le libellé de la publicité"} />
                        <Textarea
                            onKeyUp={() => setIsOk(false)}
                            {...register("Titre")}
                            defaultValue={props.pub?.[0]?.Titre}
                            required
                            rows={2}
                            label={'Titre'}
                            placeholder={"Entrez le titre de la publicité"} />
                        <Input
                            {...register("DatePub", { valueAsDate: true })}
                            defaultValue={props.pub?.[0]?.DatePub ? new Date(props.pub[0].DatePub).toISOString().split('T')[0] : ''}
                            type='date'
                            label={'Date de publication'}
                        />
                        <label className="inline-flex items-center gap-2 cursor-pointer select-none">
                            <input
                                type="checkbox"
                                {...register("Statut")}
                                defaultChecked={props.pub?.[0]?.Statut == "1"}
                                className="w-4 h-4 rounded border-[var(--eb-border)] accent-[var(--eb-primary)] focus:ring-2 focus:ring-[var(--eb-primary)]/40 cursor-pointer"
                            />
                            <span className="text-sm text-[var(--eb-text)]">Active</span>
                        </label>
                    </FormSection>

                    <FormSection title="Fichiers" subtitle="Images multiples — max 5 Mo chacune — format conseillé ~1200×800 (le cadre pub du Live Screen ≈ 3:2)">
                        <div className="full">
                            <div
                                className={`eb-pub-drop${dragOver ? ' is-over' : ''}`}
                                onClick={() => fileInputRef.current?.click()}
                                onDragOver={(e) => { e.preventDefault(); setDragOver(true) }}
                                onDragLeave={() => setDragOver(false)}
                                onDrop={(e) => {
                                    e.preventDefault(); setDragOver(false)
                                    handleFiles(e.dataTransfer.files)
                                }}
                            >
                                <ImagePlus size={26} className="eb-pub-drop-icon" />
                                <span className="eb-pub-drop-title">Glissez vos images ici ou cliquez</span>
                                <span className="eb-pub-drop-hint">PNG · JPG · SVG — plusieurs fichiers — max 5 Mo — ~1200×800 px (ratio 3:2)</span>
                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={(e) => {
                                        handleFiles(e.target.files);
                                        e.target.value = '';
                                    }}
                                    style={{ display: 'none' }}
                                />
                            </div>
                            {mediaFiles.length > 0 && (
                                <div className="eb-pub-thumbs">
                                    {mediaFiles.map((src, i) => (
                                        <div key={i} className="eb-pub-thumb">
                                            <img src={src} alt={`media ${i + 1}`} />
                                            <button type="button" className="eb-pub-thumb-remove" title="Retirer"
                                                onClick={() => removeMedia(i)}>
                                                <X size={12} />
                                            </button>
                                            <span className="eb-pub-thumb-order">{i + 1}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {mediaFiles.length > 0 && imgDims && (
                                <p className="text-xs text-[var(--eb-text-muted)] mt-1.5 mb-0">
                                    {mediaFiles.length} fichier{mediaFiles.length > 1 ? 's' : ''} — dernière image : {imgDims}
                                </p>
                            )}
                        </div>
                    </FormSection>

                    <FormSection title="Services" subtitle="Sélectionnez les services de diffusion">
                        <div className="full">
                            <Button variant="outline" startIcon={<ListChecks size={16} />}
                                onClick={() => setOpenServices(true)} type="button">
                                Choisir les services{services.length > 0 ? ` (${services.length})` : ''}
                            </Button>
                            {services.length > 0 && (
                                <div className="flex flex-wrap gap-1.5 mt-2">
                                    {services.slice(0, 4).map((id) => (
                                        <span key={id} className="px-2 py-1 rounded-md text-xs font-semibold"
                                            style={{ background: 'var(--eb-primary)14', color: 'var(--eb-primary)', border: '1px solid var(--eb-primary)33' }}>
                                            {id}
                                        </span>
                                    ))}
                                    {services.length > 4 && (
                                        <span className="text-xs text-[var(--eb-text-muted)]">+{services.length - 4} autres</span>
                                    )}
                                </div>
                            )}
                        </div>
                    </FormSection>

                    <Modal
                        open={openServices}
                        onClose={() => setOpenServices(false)}
                        title="Services de diffusion"
                        footer={<Button variant="primary" onClick={() => setOpenServices(false)}>Valider ({services.length})</Button>}
                    >
                        <PickerList
                            items={pickerItems}
                            selected={services}
                            onChange={(ids) => setservices(ids)}
                            emptyText="Aucun service disponible"
                        />
                    </Modal>

                    <FormActions>
                        <Button variant='secondary' type='submit' startIcon={<Save size={16} />}>Enregistrer</Button>
                    </FormActions>
                </form>
            </Spin>
        </>
    );
};

export default FormPubUpdate;
